/**
 * Created by Tiger on 22/02/2022.
 */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import Styles from './css/DeviceHeader.module.scss';
import {Button, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import i18n from 'i18next';
import actions from '../../redux/action';
import {connect} from 'react-redux';
import {InputItem} from '../../components/inputItem';
import {SelectItem} from '../../components/select-item';
import _ from 'lodash';

function DeviceHeader(props) {
  const [productCode, setProductCode] = useState(null);
  const [privateConfigId, setPrivateConfigId] = useState(null);
  const [mac, setMac] = useState(null);

  //防抖
  const debounce = useCallback(_.debounce(({ productCode, privateConfigId, mac }) => {
    let filter = {
      hadPrivate: true,
    };
    if (productCode) {
      filter.productCode = productCode;
    }
    if (privateConfigId) {
      filter.privateConfigId = privateConfigId;
    }
    if (mac && mac.length > 0) {
      filter.mac = mac;
    }
    props.updateDeviceFilter(filter);
    props.onRefreshDeviceList(props.language, {
      ...filter,
      offset: 0,
      limit: 50,
    });
    props.setSelectedRows([]);
  }, 500), []);

  useEffect(() => {
    debounce({ productCode, privateConfigId, mac });
  }, [productCode, privateConfigId, mac]);
  useEffect(() => {
    props.onRefreshProducts(props.language);
    props.onRefreshConfigList();
  }, [props.language]);
  return <div className={ Styles.container }>
    <Space direction={ 'horizontal' }>
      <SelectItem dropdownMatchSelectWidth={ 300 }
                  style={ { marginTop: 0, minWidth: 200 } } onChanged={ (event) => {
        setProductCode(event?.value);
      } } options={ props.products } placeholder={ i18n.t('select_device_type') }/>
      <InputItem placeholder={ 'MAC' } bordered={ 'true' } onChange={ event => setMac(event.target?.value) }/>
      <SelectItem dropdownMatchSelectWidth={ 300 }
                  style={ { marginTop: 0, minWidth: 200 } }
                  onChanged={ event => {
                    setPrivateConfigId(event?.value);
                  } } options={ props.configList } placeholder={ i18n.t('select_config') }/>
    </Space>
    <Button icon={ <PlusOutlined/> } type="primary" onClick={ props.addDevice }>{ i18n.t('add_device') }</Button>
  </div>;
}

const mapState2Props = state => ({
  language: state.language.language, configList: state.config.configList.map(({ id, name }) => ({
    label: name, value: id,
  })), products: state.config.products,
});

const mapDispatch2Props = dispatch => ({
  onRefreshConfigList: () => dispatch(actions.onRefreshConfigList()),
  onRefreshProducts: language => dispatch(actions.onRefreshProducts(language)),
  onRefreshDeviceList: (language, filter) => dispatch(actions.onDeviceList(language, filter)),
});

export default connect(mapState2Props, mapDispatch2Props)(DeviceHeader);
